import React, { Fragment } from "react";
import Header from "../../containers/Header/Header.jsx";

import classes from "./Layout.module.css";

const layout = (props) => {
  return (
    <Fragment>
      <div className={classes.container}>
        <Header />
        <main className={classes.Content}>{props.children}</main>
      </div>
    </Fragment>
  );
};

export default layout;
